import React from 'react'
import Tile from './Tile'

class TileGroup extends React.Component {
  getColor(user) {
    let userdetails = this.props.users
    let i = userdetails.find(person => {
      return person.name === user
    })
    return i.color
  }

  calculateSpan(start, end) {
    return (parseInt(end) - parseInt(start))/100
  }

  render() {
    const cellInfo = this.props.info
    const row = this.props.row
    const time = this.props.time

    let cell = cellInfo.filter((key, index) => {
      if(key.row == row) {
        return key
      } else {
        return null
      }
    })
    if(cell.length == 0) {
      return <td/>
    } else {
      if(cell[0].start == time) {
        return <Tile 
          colSpan={this.calculateSpan(cell[0].start, cell[0].end)} 
          entry={cell[0]}
          color={this.getColor(cell[0].person)}
          room={this.props.room}
        />
      } else {
        return (null)
      }
    }
  }
}

export default TileGroup
